import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

export const NumbersRangeWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`
export const NumbersRangeWrapperInner = styled('div')`
  display: flex;
  flex-direction: row;
`
export const NumbersRangeTitle = styled(Typography)`
  font-weight: 600;
`

export const NumbersRangeDivider = styled(Divider)`
  margin: 0 8px;
  height: 16px;
  align-self: center;
`
